import { render, staticRenderFns } from "./PrescriptionList.vue?vue&type=template&id=383d3056&scoped=true&"
import script from "./PrescriptionList.vue?vue&type=script&lang=js&"
export * from "./PrescriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d3056",
  null
  
)

export default component.exports